import { Button } from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';
import { useModal } from 'react-modal-hook';

import { ModalType } from 'shared/lib/analytics/modalTypes';
import { useTrackedShowModal } from 'shared/lib/analytics/useTrackedShowModal';
import { ResponsiveDialog } from 'shared/ui/ResponsiveDialog';

/**
 * Asks before logging out, and returns what the Log out control should call instead.
 *
 * A hook rather than markup because NavBar returns the mobile nav from an early branch, so its two
 * Log out controls share no place in the tree to render a dialog from. `useModal` mounts it outside
 * the caller either way.
 */
export const useLogoutConfirm = (onConfirm: VoidFunction) => {
  const [showModal, hideModal] = useModal(
    ({ in: open = false }: TransitionProps) => (
      <ResponsiveDialog
        actions={
          <>
            <Button variant="outlined" onClick={hideModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                hideModal();
                onConfirm();
              }}
            >
              Log out
            </Button>
          </>
        }
        open={open}
        subtitle="Are you sure you want to log out?"
        title="Log out"
        onClose={hideModal}
      />
    ),
    [onConfirm],
  );

  return useTrackedShowModal(showModal, ModalType.LOGOUT_CONFIRM);
};
